// API base — set REACT_APP_API_BASE_URL in `.env` (see `.env.example`).
const configuredBase = process.env.REACT_APP_API_BASE_URL?.trim();

export const baseUrl =
  configuredBase && configuredBase.length > 0
    ? configuredBase.replace(/\/+$/, "")
    : "http://localhost:9799/api/v1";

export const token = localStorage.getItem("token");
